exports.f = {}.propertyIsEnumerable;



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/_object-pie.js
 ** module id = 99
 ** module chunks = 0
 **/